<template>
  <div class="header_main">
    <div class="header_left">
      <div class="bot_notice">通知：暂无通知</div>
    </div>
    <div class="header_center">
      <div class="header_center_logo">{{companyName}}可视化平台</div>
    </div>
    <div class="header_right">
      <div class="goHome">
        <button @click="$router.push('/home')">返回系统</button>
      </div>
      <div class="header_right_weather">

<!--        <iframe scrolling="no" src="https://tianqiapi.com/api.php?style=yd&skin=pitaya&color=FFF" frameborder="0"
                width="140" height="30" allowtransparency="true"></iframe>-->
        <iframe name="weather_inc" src="http://i.tianqi.com/index.php?c=code&id=1&color=%23FFFFFF"
                width="390" height="35" frameborder="0" marginwidth="0" marginheight="0" scrolling="no">
        </iframe>

<!--        <iframe src="http://i.tianqi.com/index.php?c=code&amp;id=38&amp;icon=1&amp;num=2&amp;align=left" frameborder="0"
                width="400" scrolling="no" height="90" allowtransparency="true"></iframe>-->
      </div>

      <div class="header_right_data">
        {{ date }} {{ time }}
      </div>

    </div>
  </div>
</template>

<script>
// header
import dayjs from 'dayjs';

export default {
  name: "Header",
  components: {},
  data() {
    return {
      companyName:'',
      date: dayjs().format("YYYY-MM-DD"),
      time: dayjs().format("HH:mm:ss")
    };
  },
  computed: {
    week() {
      var datas = dayjs().day()
      var week = ['日', '一', '二', '三', '四', '五', '六']
      return week[datas]
    }
  },
  mounted() {
    var self = this;
    self.companyName=JSON.parse(localStorage.getItem("userInfo")).companyName;
    setInterval(function () {
      self.time = dayjs().format("HH:mm:ss");
    }, 1000);
  }
};
</script>

<style lang="less">
.header_main {
  height: 75px;
  overflow: hidden;
  padding: 0px 24px 0 24px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  //background: linear-gradient(to bottom, #061c32 50%, rgba(200, 200, 200, .5) 120%)
  background: linear-gradient(to left, rgba(0,0,0, .1), rgba(0,0,0, .1));
}

.header_left {
  position: absolute;
  bottom: 5px;
  display: inline-block;
}

.header_center {
  padding-top: 20px;

  .header_center_logo {
    font-size: 30px;
    font-style: normal;
    letter-spacing: 8px;
    font-weight: bold;
    font-family: sans-serif;
    color: #fff;
    padding-right: 10px;
    text-align: center;
    background: url(./img/bg_logo.png) no-repeat center;
  }

  .header_center_slogo {
    font-size: 14px;
    font-style: normal;
    letter-spacing: 0.4px;
    font-weight: bold;
    font-family: sans-serif;
    color: rgb(222, 134, 36);
    margin-top: 5px;
    text-align: center;
  }
}

.header_right {
  display: flex;
  position: absolute;
  right: 120px;
  top: 48px;

  a {
    color: #EFECEB;
  }

  .header_right_data {
    height: 30px;
    margin-top: -30px;
    color: rgba(227, 223, 221, 0.97);
    font-size: 18px;
    font-family: sans-serif;
  }

  .header_right_weather {
    margin-right: -267px;
    color: rgb(234, 224, 224);
    font-size: 14px;
    font-family: sans-serif;
    text-align: right;
  }

  .header_right_week {
    font-size: 15px;
    letter-spacing: 6px;
    font-family: sans-serif;
    color: rgb(255, 255, 255);
    margin: 0 5px;
    width: 10px;
    line-height: 21px;
  }

  .header_right_time {
    color: rgb(255, 255, 255);
    font-size: 30px;
    font-family: sans-serif;
    line-height: 35px;
    margin-left: 8px;
    padding-left: 8px;
    position: relative;
  }

  .header_right_time:before {
    position: absolute;
    left: 0;
    top: 2px;
    width: 2px;
    height: 36px;
    background: #c97c0e;
    content: ''
  }
  .goHome{
    float: left;
    margin-top: -30px;
    margin-right:30px;
    opacity: 0.5;
  }
}
</style>
